import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	utmData: [],
	referralUserName: "",
};

const OtherSlice = createSlice({
	name: "OtherSlice",
	initialState: initialState,
	reducers: {
		setUtmData(state, action) {
			state.utmData = action.payload;
		},
		setReferralUserName(state, action) {
			state.referralUserName = action.payload;
		},
	},
});

export const OtherDataActions = OtherSlice.actions;
export default OtherSlice.reducer;
